import { useSignupState } from './useSignupState'

export const useStack = () => useSignupState().stack
